import React, { useState, useEffect, useRef } from "react";
import Typed from "typed.js";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import Footer from "../Components/Footer";
import { isMobile } from "react-device-detect";
import Chart from "react-apexcharts";
import RouteApi from "../Backend/Backend";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import lottie from "lottie-web";
import confetti from 'canvas-confetti'; // only if you want confetti 🎉
import { useParams } from "react-router-dom";
import printJS from "print-js";
import { exportResultDocx } from "../utils/exportResultDocx";
import {
  DEFAULT_SCHOOL_ABREV,
  DEFAULT_SCHOOL_LOGO_URL,
  DEFAULT_SCHOOL_WEBSITE,
} from "../config/school";

const resultPreviewStyles = `
  @media screen {
    .result-preview-modal {
      background: #f4f6fb;
    }

    .result-preview-modal .report-sheet {
      width: min(100%, 1080px);
      max-width: 1080px;
      margin: 0 auto;
      padding: 26px 30px;
      background: #ffffff;
      color: #111827;
      font-family: "Times New Roman", Times, serif;
      box-shadow: 0 18px 55px rgba(17, 24, 39, 0.12);
      border: 1px solid #e4e8f0;
      border-radius: 10px;
    }

    .result-preview-modal .report-sheet-inner,
    .result-preview-modal .report-content {
      width: 100%;
      max-width: 100%;
      margin: 0;
      padding: 0;
      transform: none;
    }

    .result-preview-modal .report-header {
      display: grid;
      grid-template-columns: 120px minmax(0, 1fr) 120px;
      gap: 18px;
      align-items: center;
      margin-bottom: 18px;
    }

    .result-preview-modal .report-header-logo {
      text-align: left;
    }

    .result-preview-modal .report-header-title {
      text-align: center;
      min-width: 0;
    }

    .result-preview-modal .report-header-photo {
      text-align: right;
      min-height: 96px;
    }

    .result-preview-modal .school-logo {
      width: auto;
      max-width: 96px;
      max-height: 108px;
      object-fit: contain;
    }

    .result-preview-modal .student-passport,
    .result-preview-modal .student-passport-placeholder {
      width: 82px;
      height: 98px;
      border-radius: 8px;
      object-fit: cover;
      background: #eef2f7;
      display: inline-block;
    }

    .result-preview-modal .school-name {
      margin: 0 0 6px;
      color: #43146d;
      font-size: 30px;
      font-weight: 800;
      line-height: 1.08;
      text-align: center;
      letter-spacing: 0;
    }

    .result-preview-modal .school-address {
      margin: 0;
      color: #111827;
      font-size: 17px;
      line-height: 1.35;
      text-align: center;
    }

    .result-preview-modal .report-title {
      margin-top: 8px;
      color: #43146d;
      font-size: 22px;
      line-height: 1.1;
      font-weight: 700;
      text-align: center;
    }

    .result-preview-modal .student-info-wrapper,
    .result-preview-modal .table-responsive {
      width: 100%;
      max-width: 100%;
      overflow: visible;
      margin: 0;
      padding: 0;
    }

    .result-preview-modal table {
      width: 100%;
      border-collapse: collapse;
      border-spacing: 0;
      table-layout: fixed;
      margin: 0;
    }

    .result-preview-modal th,
    .result-preview-modal td {
      border: 1px solid #d5dce8;
      color: #111827;
      vertical-align: middle;
      white-space: normal;
      overflow-wrap: break-word;
    }

    .result-preview-modal .student-info-table {
      margin-bottom: 14px;
    }

    .result-preview-modal .student-info-table th,
    .result-preview-modal .student-info-table td {
      padding: 9px 11px;
      font-size: 14px;
      line-height: 1.25;
    }

    .result-preview-modal .student-info-table th {
      width: 11%;
      font-weight: 800;
      text-align: center;
      background: #f8fafc;
    }

    .result-preview-modal .student-info-table td {
      width: 22.333%;
      text-align: left;
      font-weight: 600;
    }

    .result-preview-modal .report-section-title {
      margin: 16px 0 8px;
      color: #43146d;
      font-size: 24px;
      font-weight: 700;
      line-height: 1.1;
      text-align: center;
    }

    .result-preview-modal .result-score-table th,
    .result-preview-modal .result-score-table td {
      padding: 8px 9px;
      font-size: 13px;
      line-height: 1.2;
      text-align: center;
    }

    .result-preview-modal .result-score-table thead th,
    .result-preview-modal .bg-purple th {
      background: #43146d;
      color: #ffffff;
      font-size: 13px;
      font-weight: 800;
    }

    .result-preview-modal .result-score-table th:first-child,
    .result-preview-modal .result-score-table td:first-child {
      width: 28%;
    }

    .result-preview-modal .result-score-table td:first-child {
      text-align: left;
      font-weight: 600;
    }

    .result-preview-modal .result-score-table th:nth-child(2),
    .result-preview-modal .result-score-table td:nth-child(2),
    .result-preview-modal .result-score-table th:nth-child(3),
    .result-preview-modal .result-score-table td:nth-child(3),
    .result-preview-modal .result-score-table th:nth-child(4),
    .result-preview-modal .result-score-table td:nth-child(4) {
      width: 9%;
    }

    .result-preview-modal .result-score-table th:nth-child(5),
    .result-preview-modal .result-score-table td:nth-child(5) {
      width: 12%;
    }

    .result-preview-modal .result-score-table th:nth-child(6),
    .result-preview-modal .result-score-table td:nth-child(6) {
      width: 8%;
    }

    .result-preview-modal .result-score-table th:nth-child(7),
    .result-preview-modal .result-score-table td:nth-child(7) {
      width: 25%;
    }

    .result-preview-modal .result-score-table.standard-result th:first-child,
    .result-preview-modal .result-score-table.standard-result td:first-child {
      width: 30%;
    }

    .result-preview-modal .result-score-table.standard-result th:nth-child(2),
    .result-preview-modal .result-score-table.standard-result td:nth-child(2),
    .result-preview-modal .result-score-table.standard-result th:nth-child(3),
    .result-preview-modal .result-score-table.standard-result td:nth-child(3),
    .result-preview-modal .result-score-table.standard-result th:nth-child(4),
    .result-preview-modal .result-score-table.standard-result td:nth-child(4),
    .result-preview-modal .result-score-table.standard-result th:nth-child(5),
    .result-preview-modal .result-score-table.standard-result td:nth-child(5) {
      width: 10%;
    }

    .result-preview-modal .result-score-table.standard-result th:nth-child(6),
    .result-preview-modal .result-score-table.standard-result td:nth-child(6) {
      width: 30%;
    }

    .result-preview-modal .result-score-table.test-result th:first-child,
    .result-preview-modal .result-score-table.test-result td:first-child {
      width: 45%;
    }

    .result-preview-modal .result-score-table.test-result th:nth-child(2),
    .result-preview-modal .result-score-table.test-result td:nth-child(2) {
      width: 20%;
    }

    .result-preview-modal .result-score-table.test-result th:nth-child(3),
    .result-preview-modal .result-score-table.test-result td:nth-child(3) {
      width: 35%;
    }

    .result-preview-modal .result-summary-table {
      margin-top: 12px;
    }

    .result-preview-modal .result-summary-table td {
      padding: 9px 10px;
      font-size: 13px;
      line-height: 1.25;
      text-align: center;
    }

    .result-preview-modal .average-cell,
    .result-preview-modal .attendance-percentage {
      color: #006266;
    }

    .result-preview-modal .behaviour-table {
      margin-top: 4px;
    }

    .result-preview-modal .behaviour-table th,
    .result-preview-modal .behaviour-table td {
      padding: 9px 11px;
      font-size: 13px;
      line-height: 1.25;
    }

    .result-preview-modal .behaviour-table th {
      width: 18%;
      text-align: center;
      font-weight: 800;
      background: #f8fafc;
    }

    .result-preview-modal .behaviour-table td {
      width: 32%;
      text-align: left;
    }

    .result-preview-modal .behaviour-table tr:nth-child(odd) td {
      background: #fbfcfe;
    }

    @media (max-width: 768px) {
      .result-preview-modal .report-sheet {
        padding: 18px 14px;
        border-radius: 8px;
      }

      .result-preview-modal .report-header {
        grid-template-columns: 78px minmax(0, 1fr) 78px;
        gap: 8px;
      }

      .result-preview-modal .school-logo {
        max-width: 68px;
        max-height: 76px;
      }

      .result-preview-modal .student-passport,
      .result-preview-modal .student-passport-placeholder {
        width: 58px;
        height: 70px;
      }

      .result-preview-modal .school-name {
        font-size: 18px;
      }

      .result-preview-modal .school-address,
      .result-preview-modal .result-score-table th,
      .result-preview-modal .result-score-table td,
      .result-preview-modal .result-summary-table td,
      .result-preview-modal .behaviour-table th,
      .result-preview-modal .behaviour-table td {
        font-size: 11px;
      }
    }
  }
`;


const Result = () => {

  const { id } = useParams();

  const [resultType, setResultType] = useState("");

  const { getResultList, sendResultToParent, fetchReportCard, sendAllResultStream, axiosInstance } = RouteApi();

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const [logs, setLogs] = useState([]);
  const [isRunning, setIsRunning] = useState(false);

  const handleStart = () => {
    if (isRunning) return;
    setLogs([]);
    setIsRunning(true);

    const resultType = localStorage.getItem("resultType") || "exam";

    const source = sendAllResultStream(
      resultType,
      (msg) => setLogs((prev) => [...prev, msg]),
      () => {
        setIsRunning(false);
        setLogs((prev) => [...prev, "🎯 Dispatch complete."]);
      },
      (err) => {
        setIsRunning(false);
        setLogs((prev) => [...prev, "❌ Connection error."]);
      }
    );
  };

  const loadResults = async (resultType) => {
    setResults([]);
    setLoading(true);
    const res = await getResultList(resultType);
    if (res.status === "success") {
      setResults(res.results);
    }
    setLoading(false);
  };

  const loadResults_ = async (resultType) => {
    const res = await getResultList(resultType);
    if (res.status === "success") {
      setResults(res.results);
    }
  };

  useEffect(() => {
    // Load results immediately
    loadResults_(resultType);

    // Auto refresh every 10 seconds
    const interval = setInterval(() => {
      loadResults_(resultType);
    }, 10000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, [resultType]);

  const MySwal = withReactContent(Swal);


  const handleSendResult = async (stud_id, resultType) => {
    // Show loading with React content
    MySwal.fire({
      title: <span className="text-lg font-medium">Sending Result</span>,
      html: (
        <div>
          <div id="lottie-loading" style={{ width: 120, height: 120, margin: "auto" }}></div>
          <p className="mt-3 text-dark">Please wait while we notify the parent.</p>
        </div>
      ),
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      customClass: {
        popup: "rounded-4 shadow-lg",
        title: "fs-t font-medium text-dark",
        htmlContainer: "text-sm text-dark",
      },
      didOpen: () => {
        lottie.loadAnimation({
          container: document.getElementById("lottie-loading"),
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: '/lotties/loading.json' // or error.lottie
        });
      },
    });

    try {
      const res = await sendResultToParent(stud_id, resultType);

      const animationPath = res.status === "success"
        ? "/lotties/success.json"
        : "/lotties/error.json";

      MySwal.fire({
        title: (
          <span className="text-lg text-dark">
            {res.status === "success" ? "✅ Result Sent" : "❌ Failed to Send"}
          </span>
        ),
        html: (
          <div style={{ textAlign: "center" }}>
            <div id="lottie-result" style={{ width: 120, height: 120, margin: "auto" }}></div>
            <p className="text-dark mt-2">{res.message || "No message returned."}</p>
          </div>
        ),
        confirmButtonText: res.status === "success" ? "Great!" : "Try Again",
        customClass: {
          popup: "rounded-4 shadow-lg",
          title: "fs-t text-dark",
          htmlContainer: "text-sm text-dark",
          confirmButton: `btn btn-${res.status === "success" ? "success" : "danger"} fw-semibold px-4 py-2 rounded-pill`,
        },
        didOpen: () => {
          lottie.loadAnimation({
            container: document.getElementById("lottie-result"),
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: animationPath,
          });

          if (res.status === "success" && typeof confetti === "function") {
            confetti(); // trigger confetti if available
          }
        },
      });

      loadResults(resultType);

    } catch (error) {
      MySwal.fire({
        icon: "error",
        title: <span className="text-lg">Unexpected Error</span>,
        html: <p>{error.message || "Something went wrong. Please try again later."}</p>,
        confirmButtonText: "Close",
        customClass: {
          popup: "rounded-4 shadow-lg",
          title: "fs-t font-medium text-dark",
          htmlContainer: "text-sm text-dark",
          confirmButton: "btn btn-danger fw-semibold px-4 py-2 rounded-pill",
        },
      });
    }


  };

  const [name, setName] = useState("");

  const [student, setStudent] = useState(null);

  const [result, setResult] = useState([]);

  const [meta, setMeta] = useState([]);

  const [prin, setPrin] = useState([]);

  const [avg, setAvg] = useState([]);


  const getCardData = async (stud_id, resultType) => {
    setLoading(true);
    const res = await fetchReportCard(stud_id, resultType);
    if (res.status === "success") {
      setStudent(res.student);
      setResult(res.results);
      setMeta(res.meta);
      setAvg(res.averages);
      setPrin(res.principal_comment)
    }
    setLoading(false);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const filteredResults = results.filter((result) => {
    const search = searchQuery.toLowerCase().trim();
  
    if (!search) return true;
  
    // DATABASE MODE
    if (resultType === "Database") {
      return (
        `${result.fstname} ${result.lstname}`.toLowerCase().includes(search) ||
        (result.stud_id ?? "").toLowerCase().includes(search) ||
        (result.stud_class ?? "").toLowerCase().includes(search) ||
        (result.stud_class_depart ?? "").toLowerCase().includes(search) ||
        (result.email_add ?? "").toLowerCase().includes(search) ||
        (result.phone_num ?? "").toLowerCase().includes(search)
      );
    }
  
    // EXAM / TEST / HOME MODE
    return (
      (result.fname ?? "").toLowerCase().includes(search) ||
      (result.stud_id ?? "").toLowerCase().includes(search) ||
      (result.stud_class ?? "").toLowerCase().includes(search)
    );
  });
  

  const printRef = useRef();

  const handlePrint = () => {
  const printArea = document.getElementById("printable-result");

  if (!printArea) {
    console.error("No printable result found.");
    return;
  }

  printJS({
    printable: "printable-result",
    type: "html",

    scanStyles: false,
    targetStyles: [],

    documentTitle: `${name || "Student"} ${resultType} Result`,

    style: `
      @page {
        size: A4 portrait;
        margin: 3mm;
      }

      html,
      body {
        width: 100% !important;
        height: auto !important;

        margin: 0 !important;
        padding: 0 !important;

        background: #ffffff !important;
        color: #111827 !important;

        font-family: Arial, "Times New Roman", Times, serif !important;
        font-weight: 500 !important;

        overflow: visible !important;

        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box !important;
      }

      /*
       * A4 portrait:
       * 210mm width - 6mm page margins = 204mm usable width.
       */
      #printable-result {
        position: relative !important;

        display: flex !important;
        flex-direction: column !important;
        justify-content: flex-start !important;
        align-items: center !important;

        width: 204mm !important;
        max-width: 204mm !important;
        min-width: 204mm !important;

        min-height: 290mm !important;
        height: auto !important;

        margin: 0 auto !important;
        padding: 0.2mm 0.7mm !important;

        background: #ffffff !important;

        overflow: visible !important;

        transform: none !important;
        zoom: 1 !important;

        page-break-before: avoid !important;
        page-break-after: avoid !important;
        page-break-inside: avoid !important;

        break-before: avoid-page !important;
        break-after: avoid-page !important;
        break-inside: avoid-page !important;
      }

      /*
       * Expand the report vertically to occupy the A4 page.
       * The pre-scale width is reduced so the enlarged sheet still
       * stays inside the printable width.
       */
      #printable-result .report-sheet-inner {
        display: block !important;

        width: 71.5% !important;
        max-width: 71.5% !important;
        min-width: 71.5% !important;

        margin: 0 auto !important;
        padding: 0 !important;

        transform: scale(1.4) !important;
        transform-origin: top center !important;

        zoom: 1 !important;
      }

      #printable-result .report-content {
        display: block !important;

        width: 100% !important;
        max-width: 100% !important;

        margin: 0 !important;
        padding: 0 !important;
      }

      /*
       * Remove Bootstrap sizing and spacing from print content.
       */
      #printable-result .container,
      #printable-result .container-fluid,
      #printable-result .card,
      #printable-result .card-body,
      #printable-result .modal-body {
        width: 100% !important;
        max-width: 100% !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      #printable-result .mb-0,
      #printable-result .mb-1,
      #printable-result .mb-2,
      #printable-result .mb-3,
      #printable-result .mb-4,
      #printable-result .mb-5,
      #printable-result .mb-6,
      #printable-result .mt-0,
      #printable-result .mt-1,
      #printable-result .mt-2,
      #printable-result .mt-3,
      #printable-result .mt-4,
      #printable-result .mt-5,
      #printable-result .mt-6,
      #printable-result .mt-n1,
      #printable-result .mt-n2,
      #printable-result .mt-n3,
      #printable-result .mt-n4,
      #printable-result .p-0,
      #printable-result .p-1,
      #printable-result .p-2,
      #printable-result .py-0,
      #printable-result .py-1,
      #printable-result .py-2,
      #printable-result .px-0,
      #printable-result .px-1,
      #printable-result .px-2 {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important;

        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      /*
       * Report header
       */
      #printable-result .report-header {
        display: grid !important;
        grid-template-columns: 14% 72% 14% !important;
        align-items: center !important;

        width: 100% !important;

        margin: 0 0 1.35mm !important;
        padding: 0 !important;
      }

      #printable-result .report-header-logo,
      #printable-result .report-header-title,
      #printable-result .report-header-photo {
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 1mm !important;
      }

      #printable-result .report-header-logo {
        text-align: left !important;
      }

      #printable-result .report-header-title {
        text-align: center !important;
      }

      #printable-result .report-header-photo {
        text-align: right !important;
      }

      #printable-result .school-name {
        margin: 0 0 1mm !important;
        padding: 0 !important;

        color: #43146d !important;

        font-size: 20px !important;
        font-weight: 700 !important;
        line-height: 1.02 !important;

        text-align: center !important;
        white-space: nowrap !important;
      }

      #printable-result .school-address {
        margin: 0 !important;
        padding: 0 !important;

        color: #111827 !important;

        font-size: 12px !important;
        font-weight: 600 !important;
        line-height: 1.08 !important;

        text-align: center !important;
      }

      #printable-result .report-title {
        margin: 0.7mm 0 0 !important;
        padding: 0 !important;

        color: #43146d !important;

        font-size: 16px !important;
        font-weight: 700 !important;
        line-height: 1.02 !important;

        text-align: center !important;
      }

      #printable-result .school-logo {
        display: inline-block !important;

        width: auto !important;
        height: auto !important;

        max-width: 22mm !important;
        max-height: 22mm !important;

        object-fit: contain !important;
      }

      #printable-result .student-passport {
        display: inline-block !important;

        width: 18mm !important;
        height: 22mm !important;

        max-width: 18mm !important;
        max-height: 22mm !important;

        border-radius: 2mm !important;

        object-fit: cover !important;
      }

      /*
       * Student information
       */
      #printable-result .student-info-wrapper {
        display: block !important;

        width: 100% !important;

        margin: 0 0 0.8mm !important;
        padding: 0 !important;
      }

      #printable-result .student-info-table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;

        margin: 0 !important;
        padding: 0 !important;

        table-layout: fixed !important;
        border-collapse: collapse !important;
        border-spacing: 0 !important;
      }

      #printable-result .student-info-table th,
      #printable-result .student-info-table td {
        height: 7mm !important;

        margin: 0 !important;
        padding: 0.75mm 1.2mm !important;

        border: 0.6px solid #cbd3df !important;

        color: #111827 !important;

        font-size: 11px !important;
        font-weight: 600 !important;
        line-height: 1.04 !important;

        vertical-align: middle !important;

        white-space: normal !important;
        overflow-wrap: break-word !important;
      }

      #printable-result .student-info-table th {
        width: 10% !important;

        font-weight: 700 !important;
        text-align: center !important;
      }

      #printable-result .student-info-table td {
        width: 23.333% !important;
        text-align: left !important;
      }

      /*
       * Section titles
       */
      #printable-result .report-section-title {
        display: block !important;

        width: 100% !important;

        margin: 1mm 0 0.75mm !important;
        padding: 0 !important;

        color: #43146d !important;

        font-size: 16px !important;
        font-weight: 700 !important;
        line-height: 1.02 !important;

        text-align: center !important;
      }

      /*
       * Generic table rules
       */
      #printable-result .table-responsive {
        display: block !important;

        width: 100% !important;
        max-width: 100% !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: visible !important;
      }

      #printable-result table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;

        margin: 0 !important;
        padding: 0 !important;

        border-collapse: collapse !important;
        border-spacing: 0 !important;

        page-break-inside: auto !important;
        break-inside: auto !important;
      }

      #printable-result thead {
        display: table-header-group !important;
      }

      #printable-result tbody {
        display: table-row-group !important;
      }

      #printable-result tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }

      /*
       * Academic table
       */
      #printable-result .result-score-table {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 100% !important;

        margin: 0 !important;

        table-layout: fixed !important;
        border-collapse: collapse !important;
      }

      #printable-result .result-score-table th,
      #printable-result .result-score-table td {
        height: 5.95mm !important;
        min-height: 5.95mm !important;

        margin: 0 !important;
        padding: 0.45mm 0.9mm !important;

        border: 0.6px solid #cbd3df !important;

        color: #111827 !important;

        font-size: 10.7px !important;
        font-weight: 600 !important;
        line-height: 1.01 !important;

        vertical-align: middle !important;

        white-space: normal !important;
        overflow-wrap: break-word !important;
        word-break: normal !important;
      }

      #printable-result .result-score-table thead th {
        height: 6.9mm !important;

        background: #43146d !important;
        background-color: #43146d !important;
        color: #ffffff !important;

        font-size: 11px !important;
        font-weight: 700 !important;
        line-height: 1.01 !important;

        text-align: center !important;
        vertical-align: middle !important;
      }

      #printable-result .result-score-table th:first-child {
        width: 28% !important;
        text-align: center !important;
      }

      #printable-result .result-score-table td:first-child {
        width: 28% !important;

        padding-left: 1.1mm !important;

        text-align: left !important;
      }

      #printable-result .result-score-table th:nth-child(2),
      #printable-result .result-score-table td:nth-child(2),
      #printable-result .result-score-table th:nth-child(3),
      #printable-result .result-score-table td:nth-child(3),
      #printable-result .result-score-table th:nth-child(4),
      #printable-result .result-score-table td:nth-child(4) {
        width: 9% !important;
        text-align: center !important;
      }

      #printable-result .result-score-table th:nth-child(5),
      #printable-result .result-score-table td:nth-child(5) {
        width: 12% !important;
        text-align: center !important;
      }

      #printable-result .result-score-table th:nth-child(6),
      #printable-result .result-score-table td:nth-child(6) {
        width: 8% !important;
        text-align: center !important;
      }

      #printable-result .result-score-table th:nth-child(7),
      #printable-result .result-score-table td:nth-child(7) {
        width: 25% !important;
        text-align: center !important;
      }

      /*
       * Standard six-column result
       */
      #printable-result .result-score-table.standard-result th:first-child,
      #printable-result .result-score-table.standard-result td:first-child {
        width: 30% !important;
      }

      #printable-result .result-score-table.standard-result th:nth-child(2),
      #printable-result .result-score-table.standard-result td:nth-child(2),
      #printable-result .result-score-table.standard-result th:nth-child(3),
      #printable-result .result-score-table.standard-result td:nth-child(3),
      #printable-result .result-score-table.standard-result th:nth-child(4),
      #printable-result .result-score-table.standard-result td:nth-child(4),
      #printable-result .result-score-table.standard-result th:nth-child(5),
      #printable-result .result-score-table.standard-result td:nth-child(5) {
        width: 10% !important;
      }

      #printable-result .result-score-table.standard-result th:nth-child(6),
      #printable-result .result-score-table.standard-result td:nth-child(6) {
        width: 30% !important;
      }

      /*
       * Test result table
       */
      #printable-result .result-score-table.test-result th:first-child,
      #printable-result .result-score-table.test-result td:first-child {
        width: 45% !important;
      }

      #printable-result .result-score-table.test-result th:nth-child(2),
      #printable-result .result-score-table.test-result td:nth-child(2) {
        width: 20% !important;
      }

      #printable-result .result-score-table.test-result th:nth-child(3),
      #printable-result .result-score-table.test-result td:nth-child(3) {
        width: 35% !important;
      }

      /*
       * Performance summary
       */
      #printable-result .result-summary-table {
        width: 100% !important;
        max-width: 100% !important;

        margin: 0.8mm 0 0 !important;

        table-layout: fixed !important;
        border-collapse: collapse !important;
      }

      #printable-result .result-summary-table td {
        height: 8.2mm !important;

        margin: 0 !important;
        padding: 0.5mm 0.8mm !important;

        border: 0.6px solid #cbd3df !important;

        color: #111827 !important;

        font-size: 10.3px !important;
        font-weight: 600 !important;
        line-height: 1.04 !important;

        text-align: center !important;
        vertical-align: middle !important;

        white-space: normal !important;
      }

      #printable-result .result-summary-table strong {
        font-size: 10.7px !important;
        font-weight: 700 !important;
      }

      #printable-result .result-summary-table .attendance-row td {
        height: 5.8mm !important;

        font-size: 10.1px !important;
        line-height: 1.02 !important;
      }

      /*
       * Behaviour and comments
       */
      #printable-result .behaviour-table {
        width: 100% !important;
        max-width: 100% !important;

        margin: 0 !important;

        table-layout: fixed !important;
        border-collapse: collapse !important;
      }

      #printable-result .behaviour-table th,
      #printable-result .behaviour-table td {
        margin: 0 !important;
        padding: 0.55mm 1mm !important;

        border: 0.6px solid #cbd3df !important;

        color: #111827 !important;

        font-size: 10.2px !important;
        font-weight: 600 !important;
        line-height: 1.02 !important;

        vertical-align: middle !important;

        white-space: normal !important;
        overflow-wrap: break-word !important;
      }

      #printable-result .behaviour-table th {
        width: 18% !important;

        font-weight: 700 !important;
        text-align: center !important;
      }

      #printable-result .behaviour-table td {
        width: 32% !important;
        text-align: left !important;
      }

      #printable-result .behaviour-table .trait-row {
        height: 5.8mm !important;
      }

      #printable-result .behaviour-table .comment-row {
        height: 8.8mm !important;
      }

      /*
       * Alternate behavioural rows
       */
      #printable-result .behaviour-table tr:nth-child(odd) th,
      #printable-result .behaviour-table tr:nth-child(odd) td {
        background-color: #f3f6fa !important;
      }

      /*
       * Print purple header backgrounds
       */
      #printable-result .bg-purple th,
      #printable-result thead.bg-purple th {
        background: #43146d !important;
        background-color: #43146d !important;
        color: #ffffff !important;
      }
    `,
  });
};

  const [searchTerm, setSearchTerm] = useState("");

  const classList = [
    "Preparatory 1",
    "Preparatory 2",
    "Reception 1",
    "Reception 2",
    "PlayGroup",
    "NUR 1",
    "NUR 2",
    "KG 1",
    "KG 2",
    "Grade 1",
    "Grade 2",
    "Grade 3",
    "Grade 4",
    "Grade 5",
    "Grade 6",
    "JSS1",
    "JSS2",
    "JSS3",
    "SSS1",
    "SSS2",
    "SSS3",
  ];

  const filteredClassList = classList.filter((className) =>
    className.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGenerate = (className) => {
    console.log("Generating report for:", className);
    // You can trigger your backend call here
  };

  // 🧠 Grade logic (mimicking your PHP exactly)
  let over_grade = "";
  let over_remark = "";

  let subject_type = "Unknown";

  const cls = result?.stud_class?.toUpperCase()?.trim() || "";

  // Define class groups for easy checking
  const seniorClasses = ["SSS1", "SSS2", "SSS3"];
  const juniorClasses = ["JSS1", "JSS2", "JSS3"];
  const primaryClasses = ["GRADE 1", "GRADE 2", "GRADE 3", "GRADE 4", "GRADE 5", "GRADE 6"];
  const nurseryClasses = ["NUR 1", "NUR 2", "KG 1", "KG 2", "PLAY GROUP", "RECEPTION 1", "RECEPTION 2", "PREPARATORY 1", "PREPARATORY 2"];

  // Determine subject type
  if (seniorClasses.includes(cls)) {
    subject_type = "Senior";
  } else if (juniorClasses.includes(cls)) {
    subject_type = "Junior";
  } else if (primaryClasses.includes(cls)) {
    subject_type = "Primary";
  } else if (nurseryClasses.includes(cls)) {
    subject_type = "Nursery";
  }


  if (subject_type === "Senior" || subject_type === "Junior") {
    if (meta?.average >= 70) {
      over_remark = "EXCELLENT";
      over_grade = "A";
    } else if (meta?.average >= 60) {
      over_remark = "VERY GOOD";
      over_grade = "B";
    } else if (meta?.average >= 50) {
      over_remark = "GOOD";
      over_grade = "C";
    } else if (meta?.average >= 40) {
      over_remark = "FAIR";
      over_grade = "D";
    } else if (meta?.average >= 30) {
      over_remark = "POOR";
      over_grade = "E";
    } else if (meta?.average >= 0) {
      over_remark = "FAIL";
      over_grade = "F";
    }
  } else {
    if (meta?.average >= 90) {
      over_remark = "OUTSTANDING";
      over_grade = "A+";
    } else if (meta?.average >= 80) {
      over_remark = "EXCELLENT";
      over_grade = "A";
    } else if (meta?.average >= 70) {
      over_remark = "IMPRESSIVE";
      over_grade = "B+";
    } else if (meta?.average >= 60) {
      over_remark = "VERY GOOD";
      over_grade = "B";
    } else if (meta?.average >= 50) {
      over_remark = "GOOD";
      over_grade = "C";
    } else if (meta?.average >= 40) {
      over_remark = "PASS";
      over_grade = "D";
    } else if (meta?.average >= 0) {
      over_remark = "POOR";
      over_grade = "E";
    }
  }

  const type = student?.school_type?.trim().toLowerCase();

  const [toggle, setToggle] = useState(true);

  const [open, setOpen] = useState(false);


  // ================= DATABASE RESULT VIEW STATES =================
  const TERMS = ["First Term", "Second Term", "Third Term"];

  const SESSIONS = [
    { key: "database_2022_2023", label: "2022 / 2023" },
    { key: "database_2023_2024", label: "2023 / 2024" },
    { key: "database_2024_2025", label: "2024 / 2025" }
  ];

  const [activeTerm, setActiveTerm] = useState("First Term");
  const [sessionKey, setSessionKey] = useState("database_2024_2025");
  const [dbData, setDbData] = useState(null);
  const [dbLoading, setDbLoading] = useState(false);
  const [dbError, setDbError] = useState(null);
  const [activeStudId, setActiveStudId] = useState(null);

  const fetchDatabaseResult = async (studid) => {
    if (!studid) return;

    setDbLoading(true);
    setDbError(null);

    setActiveStudId(studid);
  
    try {
      const token = localStorage.getItem("jwtToken");
  
      const res = await axiosInstance.post(
        "/results/generate",
        {
          stud_id: studid,
          session_key: sessionKey,
          term: activeTerm
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      if (res.data.status !== "success") {
        throw new Error(res.data.message || "Result not available");
      }
  
      setDbData(res.data);
    } catch (err) {
      console.error(err);
      setDbData(null);
      setDbError(err.message || "Failed to load database result");
    } finally {
      setDbLoading(false);
    }
  };

  useEffect(() => {
    if (resultType === "Database" && activeStudId) {
      fetchDatabaseResult(activeStudId);
    }
  }, [sessionKey, activeTerm]);

  /* ===============================
    🔧 COMPATIBILITY FIX (ADDED)
    =============================== */
  
    const {
      student: rawStudent = {},
      subjects: rawSubjects = [],
      summary = {},
      behavior = {},
      session,
      term,
      meta: backendMeta,
    } = dbData || {};
  
    // Inject missing student fields WITHOUT mutating original object
    const students = {
      ...rawStudent,
      session: rawStudent.session ?? session,
      term: rawStudent.term ?? term,
    };
  
    const resulted = rawSubjects.map((s) => ({
      ...s,

      // Current-term fields
      test: s.test ?? "",
      exam: s.exam ?? "",
      total: s.total ?? s.score ?? "",
      grade: s.grade ?? s.third_term?.grade ?? "",
      remark: s.remark ?? s.third_term?.remark ?? "",

      // Third-term cumulative structure
      first_term: {
        test: s.first_term?.test ?? "",
        exam: s.first_term?.exam ?? "",
        total: s.first_term?.total ?? "",
        grade: s.first_term?.grade ?? "",
        remark: s.first_term?.remark ?? "",
      },

      second_term: {
        test: s.second_term?.test ?? "",
        exam: s.second_term?.exam ?? "",
        total: s.second_term?.total ?? "",
        grade: s.second_term?.grade ?? "",
        remark: s.second_term?.remark ?? "",
      },

      third_term: {
        test: s.third_term?.test ?? s.test ?? "",
        exam: s.third_term?.exam ?? s.exam ?? "",
        total: s.third_term?.total ?? s.total ?? s.score ?? "",
        grade: s.third_term?.grade ?? s.grade ?? "",
        remark: s.third_term?.remark ?? s.remark ?? "",
      },

      cumulative_average:
        s.cumulative_average ??
        s.cumulative ??
        "",
    }));
  
    // Create meta object expected by JSX
    const metas = backendMeta ?? {
      mark_obtain: summary.total ? rawSubjects.length * 100 : "",
      total_mark: summary.total ?? "",
      average: summary.average ?? "",
      overall_grade: summary.overall_grade ?? "",
      overall_remark: summary.overall_remark ?? "",
      teach_com: summary.teacher_comment ?? "",
      prin_com: summary.principal_comment ?? "",
      punctuality: behavior.punctuality ?? "",
      neatness: behavior.neatness ?? "",
      honesty: behavior.honesty ?? "",
      initiative: behavior.initiative ?? "",
      politeness: behavior.politeness ?? "",
      attentive: behavior.attentive ?? "",
    };
  
    /* ===============================
       ORIGINAL CODE (UNTOUCHED)
       =============================== */
  
    const types = student?.school_type?.trim().toLowerCase();
  
    const over_grades = metas?.overall_grade ?? "";
    const over_remarks = metas?.overall_remark ?? "";
    const prins = metas?.prin_com ?? "";
  
    // sessionKey should already exist in parent or dbData
    // fallback to student/session if needed
    const currentSessionKey = dbData?.sessionKey ?? dbData?.session ?? "";
    
    // total marks from API
    const obtained = Number(metas?.total_mark || 0);
    const mark_total = Number(metas?.mark_obtain || 0);
    
    // PHP equivalent: max(obtained, mark_total)
    const marksObtainable =
      obtained >= mark_total ? obtained : mark_total;
    
    // PHP conditional session logic
    const marksObtained =
      currentSessionKey === "database_2023_2024"
        ? mark_total
        : obtained;
  
  const normalizeText = (value) =>
    String(value ?? "").trim().toLowerCase();

  const hasCumulativeTermScores = (subject) =>
    Boolean(
      subject?.first_term ||
      subject?.second_term ||
      subject?.third_term ||
      subject?.cumulative_average ||
      subject?.cumulative
    );

  const calculateCumulativeAverage = (subject) => {
    const termTotals = [
      subject?.first_term?.total,
      subject?.second_term?.total,
      subject?.third_term?.total,
    ]
      .map((score) => Number(score))
      .filter((score) => Number.isFinite(score) && score > 0);

    return termTotals.length > 0
      ? (
          termTotals.reduce((sum, score) => sum + score, 0) /
          termTotals.length
        ).toFixed(2)
      : null;
  };

  const calculateGradeRemark = (score, schoolType) => {
    const numericScore = Number(score);

    if (!Number.isFinite(numericScore)) {
      return { grade: "-", remark: "-" };
    }

    const isSecondary = ["senior", "junior"].includes(normalizeText(schoolType));

    if (isSecondary) {
      if (numericScore >= 80) return { grade: "A1", remark: "DISTINCTION" };
      if (numericScore >= 70) return { grade: "B2", remark: "VERY GOOD" };
      if (numericScore >= 65) return { grade: "B3", remark: "GOOD" };
      if (numericScore >= 60) return { grade: "C4", remark: "GOOD CREDIT" };
      if (numericScore >= 55) return { grade: "C5", remark: "CREDIT" };
      if (numericScore >= 50) return { grade: "C6", remark: "CREDIT" };
      if (numericScore >= 45) return { grade: "D7", remark: "PASS" };
      if (numericScore >= 40) return { grade: "E8", remark: "PASS" };
      return { grade: "F9", remark: "FAIL" };
    }

    if (numericScore >= 80) return { grade: "A", remark: "EXCELLENT" };
    if (numericScore >= 70) return { grade: "B", remark: "VERY GOOD" };
    if (numericScore >= 60) return { grade: "C", remark: "GOOD" };
    if (numericScore >= 50) return { grade: "D", remark: "AVERAGE" };
    if (numericScore >= 40) return { grade: "E", remark: "FAIR" };
    return { grade: "F", remark: "FAIL" };
  };

  const isThirdTerm =
    normalizeText(students?.term) === "third term";

  const isTestResult =
    normalizeText(resultType) === "test";

  const isSSS3 =
    normalizeText(students?.class) === "sss3";

  const displayValue = (value) =>
    value === null || value === undefined || value === "" ? "-" : value;

  const shouldShowDbCumulativeTable =
    isThirdTerm && !isTestResult && resulted.some(hasCumulativeTermScores);

  const isReportThirdTerm =
    normalizeText(student?.term) === "third term";

  const shouldShowReportCumulativeTable =
    isReportThirdTerm && !isTestResult && result.some(hasCumulativeTermScores);

  const handleExportDbWord = () => {
    exportResultDocx({
      id,
      student: students,
      results: resulted,
      meta: metas,
      resultType,
      type: types,
      overGrade: over_grades,
      overRemark: over_remarks,
      principalComment: prins,
      isCumulative: shouldShowDbCumulativeTable,
      calculateCumulativeAverage,
      calculateGradeRemark,
    });
  };

  const handleExportReportWord = () => {
    exportResultDocx({
      id,
      student,
      results: result,
      meta,
      resultType,
      type,
      overGrade: over_grade,
      overRemark: over_remark,
      principalComment: prin,
      isCumulative: shouldShowReportCumulativeTable,
      calculateCumulativeAverage,
      calculateGradeRemark,
    });
  };

  return (
    <div className="bg-back">
      <style>{resultPreviewStyles}</style>
      <Header />
      <Sidebar />

      <div className="docs-wrapper bg-back">
        <div className="container-fluid pt-lg-10 pt-12 pb-10 pb-lg-10">
          <div className="px-4 px-lg-4">
            <div className="row align-items-center gx-6">
              <div className="col-12 mb-6">
                <div className="fs-t text-q2 fw-medium">
                  <i className="bi bi-stars text-warning"></i>
                  <span className="ms-2">Get Ready For E-Report Pro</span>
                </div>
              </div>

              <div
                className="col-lg-4 mb-6"
              >
                <div
                  className="card bg-card1 p-4 text-center justify-content-center position-relative overflow-hidden shadow-none cursor-pointer"
                  style={{
                    borderRadius: "20px",
                    color: "white",
                  }}
                  onClick={() => {
                    setResultType("Exam");
                    loadResults("Exam");
                  }}
                >
                  <i
                    className="bi bi-journal-text position-absolute"
                    style={{
                      fontSize: "5rem",
                      top: "-20px",
                      right: "-20px",
                      transform: "rotate(-25deg)",
                      opacity: 0.15,
                      pointerEvents: "none",
                    }}
                  ></i>
                  <div className="text-center px-8">
                    <div className="text-white fw-semibold fs-4">
                      Access Exam Results
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-4 mb-6"
              >
                <div
                  className="card bg-card1 p-4 text-center justify-content-center position-relative overflow-hidden shadow-none cursor-pointer"
                  style={{
                    borderRadius: "20px",
                    color: "white",
                  }}
                  onClick={() => {
                    setResultType("Test");
                    loadResults("Test");
                  }}
                >
                  <i
                    className="bi bi-journal-text position-absolute"
                    style={{
                      fontSize: "5rem",
                      top: "-20px",
                      right: "-20px",
                      transform: "rotate(-25deg)",
                      opacity: 0.15,
                      pointerEvents: "none",
                    }}
                  ></i>
                  <div className="text-center px-8">
                    <div className="text-white fw-semibold fs-4">
                      Access Test Results
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-4 mb-6"
              >
                <div
                  className="card bg-card2 p-4 text-center justify-content-center position-relative overflow-hidden shadow-none cursor-pointer"
                  style={{
                    borderRadius: "20px",
                    color: "white",
                  }}
                  onClick={() => {
                    setResultType(id === 'sac' ? "Database" : "Home");
                    loadResults(id === 'sac' ? "Database" :   "Home");
                  }}
                >
                  <i
                    className="bi bi-journal-text position-absolute"
                    style={{
                      fontSize: "5rem",
                      top: "-20px",
                      right: "-20px",
                      transform: "rotate(-25deg)",
                      opacity: 0.15,
                      pointerEvents: "none",
                    }}
                  ></i>
                  <div className="text-center px-6">
                    <div className="text-white fw-semibold fs-4">
                      {id === 'sac' ? "Access Database Results" : "Access Assignment Results"}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="row align-items-center gx-6 px-lg-4 px-2 mb-6">

            {resultType !== '' ? (
              <div className="col-lg-12 mb-4">
                <div
                  className="card bg-white py-4 px-2 justify-content-center position-relative overflow-hidden 
                shadow-none cursor-pointer"
                  style={{
                    borderRadius: "20px",
                  }}
                >
                  <div className="card-header border-0">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="fs-t1 text-purple2">
                        <i className="bi bi-file-earmark-text me-1"></i> All{" "}
                        {resultType} Results
                      </div>

                      <button
                        className="btn btn-dark btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
                        onClick={() => setResultType('')}
                      >
                        <i className="bi bi-x-lg fw-bold fs-3 text-white"></i>
                      </button>
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="d-flex px-lg-4 row align-items-center">
                      <div className="col-lg-9 position-relative mb-4">
                      <input
                        type="text"
                        className="form-control form-control-lg text-dark bg-back fs-4 rounded-pill ps-8"
                        style={{ paddingLeft: "2.5rem" }}
                        placeholder={
                          resultType === "Database"
                            ? "Search name, class, department, email or phone"
                            : "Search name, class or student ID"
                        }
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />

                        <i
                          className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-4 text-muted"
                          style={{ fontSize: "1.5rem" }}
                        ></i>
                      </div>

                      {resultType !== "Database" ? (
                        <div className="col-lg-3 text-lg-end mb-4">
                          <button
                            className="btn btn-md btn-purple rounded-pill"
                            onClick={() => { handleStart(); setOpen(true); }}
                            disabled={isRunning}
                            {...(!open && {
                              "data-bs-toggle": "offcanvas",
                              "data-bs-target": "#offcanvasBottom",
                              "aria-controls": "offcanvasBottom",
                            })}
                      >
                        {isRunning ? "Sending..." : "Send All Results"}
                      </button>
                      </div>
                      ) : <></>}

                    </div>


                    <div className="table-responsive mb-6" style={{ maxHeight: "500px", overflowY: "auto" }}>
                      {loading ? (
                        <div className="text-center py-4">
                          <div className="lds-facebook mx-auto">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      ) : (
                        <table
                          className="table table-borderless table-align-middle mb-0 text-center"
                          style={{ fontSize: "1.05rem" }}
                        >
                          <thead>
                            <tr>
                              <th className="fw-medium text-dark">No.</th>
                              <th className="fw-medium text-dark">Name</th>
                              <th className="fw-medium text-dark">Class</th>

                              {resultType !== "Database" ? (
                                <>
                                  <th className="fw-medium text-dark">Sent Status</th>
                                  <th className="fw-medium text-dark">Mark Obtained</th>
                                  <th className="fw-medium text-dark">Percentage</th>
                                </>
                              ) : (
                                <>
                                  <th className="fw-medium text-dark">Department</th>
                                  <th className="fw-medium text-dark">Email</th>
                                  <th className="fw-medium text-dark">Phone</th>
                                </>
                              )}

                              <th className="fw-medium text-dark text-start">Action</th>
                            </tr>
                          </thead>
                      
                          <tbody>
                            {filteredResults.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-muted py-5">
                                  No records found.
                                </td>
                              </tr>
                            ) : (
                              filteredResults.map((result, i) => (
                                <tr key={i}>
                                  <td className="text-dark">{i + 1}</td>

                                  {/* NAME */}
                                  <td>
                                    <span className="text-dark fs-5">
                                      {resultType === "Database"
                                        ? `${result.fstname} ${result.lstname}`
                                        : result.fname}
                                    </span>
                                  </td>

                                  {/* CLASS */}
                                  <td>
                                    <span className="text-dark fs-5">
                                      {result.stud_class}
                                    </span>
                                  </td>

                                  {/* DATABASE MODE */}
                                  {resultType === "Database" ? (
                                    <>
                                      <td>
                                        <span className="text-dark fs-5">
                                          {result.stud_class_depart}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="text-dark fs-5">
                                          {result.email_add}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="text-dark fs-5">
                                          {result.phone_num}
                                        </span>
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      {/* SENT STATUS */}
                                      <td>
                                        {Number(result?.sent_status) >= 1 ? (
                                          <span className="badge bg-success-soft text-success rounded-pill fs-5">
                                            <i className="bi bi-check-circle me-1"></i> Sent
                                          </span>
                                        ) : (
                                          <span className="badge bg-primary-soft text-primary rounded-pill fs-5">
                                            <i className="bi bi-hourglass-split me-1"></i> Not Sent
                                          </span>
                                        )}
                                      </td>

                                      {/* MARK OBTAINED */}
                                      <td>
                                        <span className="text-dark fs-5">
                                          {result.mark_obtain}
                                        </span>
                                      </td>

                                      {/* PERCENTAGE */}
                                      <td>
                                        <span className="text-dark fs-5">
                                          {result.average}%
                                        </span>
                                      </td>
                                    </>
                                  )}

                                  {/* ACTIONS */}
                                  <td>
                                    <div className="d-flex gap-3">
                                      {resultType !== "Database" && (
                                        <button
                                          className="btn btn-sm btn-light-success rounded-pill text-purple2"
                                          title="Send Result"
                                          onClick={() =>
                                            handleSendResult(result.stud_id, resultType)
                                          }
                                        >
                                          <i className="bi bi-send-check me-1"></i>
                                        </button>
                                      )}

                                      <button
                                        className="btn btn-sm btn-purple4 rounded-pill text-white"
                                        data-bs-toggle="modal"
                                        data-bs-target="#print_result"
                                        title={resultType === "Database" ? "View Student" : "Print Result"}
                                        onClick={() => {
                                          // ❌ Do NOT call getCardData for Database
                                          if (resultType !== "Database") {
                                            getCardData(result.stud_id, resultType);
                                          }else{
                                            fetchDatabaseResult(result.stud_id);
                                          }

                                          // ✅ Name should still be set for both
                                          setName(
                                            resultType === "Database"
                                              ? `${result.fstname} ${result.lstname}`
                                              : result.fname
                                          );
                                        }}
                                      >
                                        <i className="bi bi-file-earmark-text me-1"></i>
                                      </button>

                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>

                        </table>
                      )}
                    </div>

                    <div className="card-footer border-0 mt-lg-n4">
                      <div className="col-12 text-center">
                        <button className="btn btn-md btn-dark rounded-pill">
                          <i className="bi bi-stars text-warning fs-3"></i> Print Results
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>

          <div className="row align-items-center gx-6 px-lg-4 px-2">

            <div className="col-lg-12 mb-4">
              <div
                className="card bg-white p-4 justify-content-center position-relative overflow-hidden
               shadow-none cursor-pointer"
                style={{
                  borderRadius: "20px",
                }}
              >
                <div className="">
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="col">
                      <span>
                        <i className="bi bi-card-checklist text-primary fs-t"></i>
                        <span className="ms-2 fs-t fw-medium">
                          Generate Braodsheet
                        </span>
                      </span>
                    </div>

                    <div className="col-end text-end"></div>
                  </div>

                  <div className="">
                    <div className="col-lg-7 position-relative py-4">
                      <input
                        className="form-control form-control-lg text-dark bg-back fs-4 rounded-pill ps-8"
                        placeholder="Search students by name, class, or student ID"
                        style={{ paddingLeft: "2.5rem" }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                      />
                      <i
                        className="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-4 text-muted"
                        style={{ fontSize: "1.5rem" }}
                      ></i>
                    </div>

                    <div className="table-responsive">
                      <table
                        className="table table-borderless table-align-middle mb-0 text-center"
                        style={{ fontSize: "1.05rem" }}
                      >
                        <thead>
                          <tr>
                            <th className="fw-medium text-dark">No.</th>
                            <th className="fw-medium text-dark">Class</th>
                            <th className="fw-medium text-dark">Teacher</th>
                            <th className="fw-medium text-dark">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredClassList.map((className, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>
                                <div className=" text-center">
                                  <span className="text-dark fs-5 fw-medium">{className.toUpperCase()}</span>
                                </div>
                              </td>
                              <td>
                                <div className=" text-center">
                                  <span className="text-dark fs-5 fw-medium">Omolade Paul</span>
                                </div>
                              </td>
                              <td>
                                <button
                                  className="btn btn-purple4 rounded-pill px-4 py-2 text-white"
                                  onClick={() => handleGenerate(className)}
                                >
                                  <i className="bi bi-file-earmark-text fs-4 d-none d-lg-block"></i>
                                  <span className="fs-5 fw-medium">Generate</span>
                                </button>
                              </td>
                            </tr>
                          ))}

                          {filteredClassList.length === 0 && (
                            <tr>
                              <td colSpan="4" className="text-center text-muted py-3">
                                No class matches your search.
                              </td>
                            </tr>
                          )}

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="print_result"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="students"
        aria-hidden="true"
      >
        <div
            className={
              isMobile
                ? "modal-dialog modal-fullscreen"
                : "modal-dialog modal-dialog-centered"
            }
            style={
              isMobile
                ? undefined
                : {
                    maxWidth: "96vw",
                    width: "96vw",
                  }
            }
          >
          <div
            className={isMobile ? "modal-content" : "modal-content"}
            style={
              isMobile
                ? { border: "#fff" }
                : { borderRadius: "30px", border: "#fff" }
            }
          >
            <div className="modal-header border-0 mt-4">
              <div className="fs-t1 text-purple2">
                <i className="bi bi-file-earmark-text me-1"></i>
                {name} Results
              </div>

              <button
                className="btn btn-dark btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="bi bi-x-lg fw-bold fs-3 text-white"></i>
              </button>
            </div>

            <div className="modal-body result-preview-modal py-0 mt-2 mb-4" ref={printRef}>
             
              {resultType === "Database" && dbData !== null ? (
                <>
                
                  {/* ===== SESSION SELECT ===== */}
                  <div className="mb-3">
                    <div className="fw-medium fs-4 text-dark">Select Session</div>
                    
                    <select
                      className="form-select form-select-lg text-dark bg-back fs-4 rounded-pill"
                      value={sessionKey}
                      onChange={(e) => setSessionKey(e.target.value)}
                    >
                      {SESSIONS.map((s) => (
                        <option key={s.key} value={s.key}>
                          {s.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* ===== TERM TABS ===== */}
                  <ul className="nav nav-pills justify-content-center mb-4">
                    {TERMS.map((term) => (
                      <li className="nav-item" key={term}>
                        <button
                          className={`nav-link btn-purple3 text-${activeTerm === term ? "white" : "dark"} ${activeTerm === term ? "active" : ""}`}
                          onClick={() => setActiveTerm(term)}
                        >
                          {term}
                        </button>
                      </li>
                    ))}
                  </ul>

                  {/* ===== CONTENT ===== */}
                  {dbLoading && (
                    <div className="text-center py-5">
                      <span className="spinner-border text-primary"></span>
                      <p className="mt-2">
                        Loading {activeTerm} (
                        {sessionKey.replace("database_", "").replace("_", " / ")})
                      </p>
                    </div>
                  )}

                  {dbError && (
                    <div className="alert alert-danger text-center">
                      {dbError}
                    </div>
                  )}
                  
                  <div id="printable-result" className="report-sheet">
                  <div className="report-sheet-inner">
                    <div className="report-content">
                    
                  <div className="mb-0 p-0">

                    {/* === HEADER === */}
                    <div className="report-header">
                      <div className="report-header-logo">
                        <img
                          src={
                            id === "cry"
                              ? "https://smartedung.com/cry.png"
                              : id === DEFAULT_SCHOOL_ABREV
                              ? DEFAULT_SCHOOL_LOGO_URL
                              : types === "primary" || types === "nursery"
                              ? "https://smartedung.com/SAC/secureadmin---/panel/img/PRIMARY.png"
                              : "https://smartedung.com/sac/logo.png"
                          }
                          alt="School Logo"
                          className="school-logo"
                        />
                      </div>

                      <div className="report-header-title">
                        <h2 className="school-name">
                          {id === "racy"
                            ? "RACY & STURDY SCHOOLS"
                            : id === DEFAULT_SCHOOL_ABREV
                            ? `EBUN HERITAGE ${
                                types === "primary" || types === "nursery"
                                  ? "FOUNDATION SCHOOL"
                                  : "HIGH SCHOOL"
                              }`
                            : `ST AUGUSTINE'S ${
                                types === "primary" || types === "nursery"
                                  ? "NURSERY/PRIMARY SCHOOL"
                                  : "COLLEGE"
                              }`}
                        </h2>

                        <p className="school-address">
                          {id === DEFAULT_SCHOOL_ABREV
                            ? students?.school === "AKESAN"
                              ? "18, Imam Saliu Street, Afolabi Bus-stop, Igando Rd, Lagos."
                              : students?.school === "LIASU"
                              ? "101, Liasu Road, Egbe-Idimu, Lagos."
                              : "22, Tolu Aluko Str., Off Liasu Rd, Council-Idimu, Lagos."
                            : "No. 7, St Augustine's Street, Idimu-Titun, Lagos State."}

                          <br />

                          Website:{" "}
                          {id === DEFAULT_SCHOOL_ABREV
                            ? DEFAULT_SCHOOL_WEBSITE
                            : "staugustinesschool.com"}
                        </p>

                        <div className="report-title">
                          {types === "primary" || types === "nursery"
                            ? "Pupil's Report Sheet"
                            : "Student's Report Sheet"}
                        </div>
                      </div>

                      <div className="report-header-photo">
                        {students?.image && (
                          <img
                            src={`https://smartedung.com/${id}/admin/dist/student/${students.image}`}
                            alt="Student Passport"
                            className="student-passport"
                          />
                        )}
                      </div>
                    </div>

                    {/* === STUDENT INFO === */}
                    <div className="student-info-wrapper">
                      <table className="student-info-table">
                        <tbody>
                          <tr>
                            <th>NAME</th>
                            <td>{students?.name}</td>

                            <th>STUDENT ID</th>
                            <td>{students?.id}</td>

                            <th>SEX</th>
                            <td>{students?.sex}</td>
                          </tr>

                          <tr>
                            <th>TERM</th>
                            <td>{students?.term}</td>

                            <th>SESSION</th>
                            <td>{students?.session}</td>

                            <th>CLASS</th>
                            <td>{students?.class}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* === ACADEMIC PERFORMANCE === */}
                    <div className="report-section-title">
                      Academic Performance
                    </div>

                    <div className="table-responsive">
                      <table
                        className={`result-score-table ${
                          shouldShowDbCumulativeTable
                            ? "cumulative-result"
                            : isTestResult
                            ? "test-result"
                            : "standard-result"
                        }`}
                      >
                        <thead className="bg-purple">
                          {shouldShowDbCumulativeTable ? (
                            <tr>
                              <th>Subject</th>
                              <th>First Term</th>
                              <th>Second Term</th>
                              <th>Third Term</th>
                              <th>Cumulative</th>
                              <th>Grade</th>
                              <th>Remark</th>
                            </tr>
                          ) : (
                            <tr>
                              <th>Subject</th>

                              {!isSSS3 && (
                                <th>{isTestResult ? "Test Score" : "Test"}</th>
                              )}

                              {!isTestResult && (
                                <>
                                  <th>Exam</th>
                                  <th>Total</th>
                                  <th>Grade</th>
                                </>
                              )}

                              <th>Remark</th>
                            </tr>
                          )}
                        </thead>

                        <tbody>
                          {resulted?.map((r, index) => {
                            const calculatedCumulative =
                              calculateCumulativeAverage(r);

                            const cumulativeScore =
                              r.cumulative_average ?? calculatedCumulative;

                            const cumulativeGradeRemark =
                              calculateGradeRemark(
                                cumulativeScore,
                                students?.school_type
                              );

                            return (
                              <tr key={r.id ?? `${r.subject}-${index}`}>
                                <td>{displayValue(r.subject)}</td>

                                {shouldShowDbCumulativeTable ? (
                                  <>
                                    <td>{displayValue(r.first_term?.total)}</td>
                                    <td>{displayValue(r.second_term?.total)}</td>
                                    <td>{displayValue(r.third_term?.total)}</td>
                                    <td>{displayValue(cumulativeScore)}</td>
                                    <td>
                                      {displayValue(cumulativeGradeRemark.grade)}
                                    </td>
                                    <td>
                                      {displayValue(cumulativeGradeRemark.remark)}
                                    </td>
                                  </>
                                ) : (
                                  <>
                                    {!isSSS3 && (
                                      <td>{displayValue(r.test)}</td>
                                    )}

                                    {!isTestResult && (
                                      <>
                                        <td>{displayValue(r.exam)}</td>
                                        <td>{displayValue(r.total)}</td>
                                        <td>{displayValue(r.grade)}</td>
                                      </>
                                    )}

                                    <td>{displayValue(r.remark)}</td>
                                  </>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* === PERFORMANCE SUMMARY === */}
                    <div className="table-responsive py-0">
                      <table className="table table-row-dashed table-row-gray-500 result-summary-table">
                        <thead>
                          <tr>
                          <td className="text-center fs-4 text-dark">
                              <span className="fw-medium">Marks Obtainable:</span>{" "}
                              {marksObtainable}
                            </td>

                            <td className="text-center fs-4 text-dark">
                              <span className="fw-medium">Marks Obtained:</span>{" "}
                              {marksObtained}
                            </td>
                            <td className="text-center fs-4" style={{ color: "#006266" }}>
                              <strong>AVERAGE: {metas?.average}</strong>
                            </td>
                            <td className="text-center fs-4 text-dark">
                              <span className="fw-medium">Overall Grade:</span>{" "}
                              {over_grades}
                            </td>
                            <td className="text-center fs-4 text-dark">
                              <span className="fw-medium">Overall Remark:</span>{" "}
                              {over_remarks}
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>

                    {/* === CHARACTER & COMMENTS === */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-center fs-3 text-purple2 py-0">
                          Behavioural / Teacher Comments
                        </div>

                        <table className="table table-bordered table-striped behaviour-table">
                          <tbody>
                            {resultType !== "Test" && (
                              <>
                                <tr>
                                  <th>Punctuality</th>
                                  <td>{metas?.punctuality}</td>
                                  <th>Neatness</th>
                                  <td>{metas?.neatness}</td>
                                </tr>
                                <tr>
                                  <th>Honesty</th>
                                  <td>{metas?.honesty}</td>
                                  <th>Initiative</th>
                                  <td>{metas?.initiative}</td>
                                </tr>
                                <tr>
                                  <th>Politeness</th>
                                  <td>{metas?.politeness}</td>
                                  <th>Attentive</th>
                                  <td>{metas?.attentive}</td>
                                </tr>
                              </>
                            )}

                            <tr>
                              <th>Teacher's Comment</th>
                              <td colSpan="3">{metas?.teach_com}</td>
                            </tr>

                            <tr>
                              <th>Principal's Comment</th>
                              <td colSpan="3">{prins}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    </div>

                    </div>
                  </div>
                  </div>

                  <div className="mt-6">
                  <div className="col-12 text-center">
                  <button
                          onClick={handlePrint}
                          className="btn btn-lg btn-dark rounded-pill me-2"
                        >
                          Print Result
                  </button>
                  <button
                          onClick={handleExportDbWord}
                          className="btn btn-lg btn-purple4 text-white rounded-pill"
                        >
                          Export Word
                  </button>
                  </div>
                  </div>
                </>
              ) : resultType === "Exam" || resultType === "Test" ? (
                
                <>
  <div id="printable-result" className="report-sheet">
    <div className="report-sheet-inner">
      <div className="report-content">

        {/* ================= HEADER ================= */}
        <div className="report-header">
          <div className="report-header-logo">
            <img
              src={
                id === "cry"
                  ? "https://smartedung.com/cry.png"
                  : id === DEFAULT_SCHOOL_ABREV
                  ? DEFAULT_SCHOOL_LOGO_URL
                  : type === "primary" || type === "nursery"
                  ? "https://smartedung.com/SAC/secureadmin---/panel/img/PRIMARY.png"
                  : "https://smartedung.com/sac/logo.png"
              }
              alt="School Logo"
              className="school-logo"
            />
          </div>

          <div className="report-header-title">
            <h2 className="school-name">
              {id === "racy"
                ? "RACY & STURDY SCHOOLS"
                : id === DEFAULT_SCHOOL_ABREV
                ? `EBUN HERITAGE ${
                    type === "primary" || type === "nursery"
                      ? "FOUNDATION SCHOOL"
                      : "HIGH SCHOOL"
                  }`
                : `ST AUGUSTINE'S ${
                    type === "primary" || type === "nursery"
                      ? "NURSERY/PRIMARY SCHOOL"
                      : "COLLEGE"
                  }`}
            </h2>

            <p className="school-address">
              {id === "racy"
                ? "Address Coming Soon"
                : id === DEFAULT_SCHOOL_ABREV
                ? student?.school === "LIASU"
                  ? "101, Liasu Road, Egbe-Idimu, Lagos."
                  : student?.school === "AKESAN"
                  ? "18, Imam Saliu Street, Afolabi Bus-stop, Igando Road, Lagos."
                  : "22, Tolu Aluko Street, Off Liasu Road, Council-Idimu, Lagos."
                : "No. 7, St Augustine's Street, Idimu-Titun, Lagos State."}

              <br />

              Website:{" "}
              {id === "cry"
                ? "Coming Soon"
                : id === DEFAULT_SCHOOL_ABREV
                ? DEFAULT_SCHOOL_WEBSITE
                : "staugustinesschool.com"}
            </p>

            <div className="report-title">
              {type === "primary" || type === "nursery"
                ? "Pupil's Report Sheet"
                : "Student's Report Sheet"}
            </div>
          </div>

          <div className="report-header-photo">
            {student?.image ? (
              <img
                src={`https://smartedung.com/${id}/admin/dist/student/${student.image}`}
                alt="Student Passport"
                className="student-passport"
              />
            ) : (
              <div className="student-passport-placeholder" />
            )}
          </div>
        </div>

        {/* ================= STUDENT INFORMATION ================= */}
        <div className="student-info-wrapper">
          <table className="student-info-table">
            <tbody>
              <tr>
                <th>NAME</th>
                <td>{displayValue(student?.name)}</td>

                <th>STUDENT ID</th>
                <td>{displayValue(student?.id)}</td>

                <th>SEX</th>
                <td>{displayValue(student?.sex)}</td>
              </tr>

              <tr>
                <th>TERM</th>
                <td>{displayValue(student?.term)}</td>

                <th>SESSION</th>
                <td>{displayValue(student?.session)}</td>

                <th>CLASS</th>
                <td>{displayValue(student?.class)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* ================= ACADEMIC PERFORMANCE ================= */}
        <div className="report-section-title">
          Academic Performance
        </div>

        <div className="table-responsive">
          <table
            className={`result-score-table ${
              shouldShowReportCumulativeTable
                ? "cumulative-result"
                : resultType === "Test"
                ? "test-result"
                : "standard-result"
            }`}
          >
            <thead className="bg-purple">
              {shouldShowReportCumulativeTable ? (
                <tr>
                  <th>Subject</th>
                  <th>First Term</th>
                  <th>Second Term</th>
                  <th>Third Term</th>
                  <th>Cumulative</th>
                  <th>Grade</th>
                  <th>Remark</th>
                </tr>
              ) : (
                <tr>
                  <th>Subject</th>
                  <th>{resultType === "Test" ? "Test Score" : "Test"}</th>

                  {resultType !== "Test" && (
                    <>
                      <th>Exam</th>
                      <th>Total</th>
                      <th>Grade</th>
                    </>
                  )}

                  <th>Remark</th>
                </tr>
              )}
            </thead>

            <tbody>
              {result?.map((r, index) => {
                const calculatedCumulative =
                  calculateCumulativeAverage(r);

                const cumulativeScore =
                  r.cumulative_average ??
                  calculatedCumulative;

                const cumulativeGradeRemark =
                  calculateGradeRemark(
                    cumulativeScore,
                    student?.school_type
                  );

                return (
                  <tr key={r.id ?? `${r.subject}-${index}`}>
                    <td>{displayValue(r.subject)}</td>

                    {shouldShowReportCumulativeTable ? (
                      <>
                        <td>
                          {displayValue(r.first_term?.total)}
                        </td>

                        <td>
                          {displayValue(r.second_term?.total)}
                        </td>

                        <td>
                          {displayValue(r.third_term?.total)}
                        </td>

                        <td>
                          {displayValue(cumulativeScore)}
                        </td>

                        <td>
                          {displayValue(
                            cumulativeGradeRemark.grade
                          )}
                        </td>

                        <td>
                          {displayValue(
                            cumulativeGradeRemark.remark
                          )}
                        </td>
                      </>
                    ) : (
                      <>
                        <td>
                          {displayValue(
                            id === DEFAULT_SCHOOL_ABREV &&
                            resultType === "Test"
                              ? r.test_1
                              : r.test
                          )}
                        </td>

                        {resultType !== "Test" && (
                          <>
                            <td>
                              {displayValue(r.exam)}
                            </td>

                            <td>
                              {displayValue(r.total)}
                            </td>

                            <td>
                              {displayValue(r.grade)}
                            </td>
                          </>
                        )}

                        <td>
                          {displayValue(r.remark)}
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* ================= PERFORMANCE SUMMARY ================= */}
        <div className="table-responsive">
          <table className="result-summary-table">
            <tbody>
              <tr>
                <td>
                  <strong>Marks Obtainable:</strong>{" "}
                  {displayValue(meta?.total_mark)}
                </td>

                <td>
                  <strong>Marks Obtained:</strong>{" "}
                  {displayValue(meta?.mark_obtain)}
                </td>

                <td className="average-cell">
                  <strong>
                    AVERAGE: {displayValue(meta?.average)}
                  </strong>
                </td>

                <td>
                  <strong>Overall Grade:</strong>{" "}
                  {displayValue(over_grade)}
                </td>

                <td>
                  <strong>Overall Remark:</strong>{" "}
                  {displayValue(over_remark)}
                </td>
              </tr>

              {resultType !== "Test" && (
                <tr className="attendance-row">
                  <td colSpan="5">
                    <strong>Attendance:</strong>{" "}
                    {displayValue(meta?.time_present)} /{" "}
                    {displayValue(meta?.school_open)}

                    &nbsp;&nbsp;

                    <span className="attendance-percentage">
                      (
                      {Number(meta?.school_open) > 0
                        ? `${Math.round(
                            (Number(meta?.time_present) /
                              Number(meta?.school_open)) *
                              100
                          )}%`
                        : "N/A"}{" "}
                      present)
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ================= BEHAVIOURAL COMMENTS ================= */}
        <div className="report-section-title">
          Behavioural / Teacher Comments
        </div>

        <table className="behaviour-table">
          <tbody>
            {resultType !== "Test" && (
              <>
                <tr className="trait-row">
                  <th>Punctuality</th>
                  <td>{displayValue(meta?.punctuality)}</td>

                  <th>Neatness</th>
                  <td>{displayValue(meta?.neatness)}</td>
                </tr>

                <tr className="trait-row">
                  <th>Honesty</th>
                  <td>{displayValue(meta?.honesty)}</td>

                  <th>Initiative</th>
                  <td>{displayValue(meta?.initiative)}</td>
                </tr>

                <tr className="trait-row">
                  <th>Politeness</th>
                  <td>{displayValue(meta?.politeness)}</td>

                  <th>Attentive</th>
                  <td>{displayValue(meta?.attentive)}</td>
                </tr>
              </>
            )}

            <tr className="comment-row">
              <th>Teacher's Comment</th>
              <td colSpan="3">
                {displayValue(meta?.teach_com)}
              </td>
            </tr>

            <tr className="comment-row">
              <th>Principal's Comment</th>
              <td colSpan="3">
                {displayValue(prin)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  {/* ================= ACTION BUTTONS ================= */}
  <div className="mt-6">
    <div className="col-12 text-center">
      {(() => {
        const metaAverage = Number.parseFloat(
          meta?.average ?? 0
        );

        const testAverage = Number.parseFloat(
          avg?.test_average ?? 0
        );

        const examAverage = Number.parseFloat(
          avg?.exam_average ?? 0
        );

        const normalizedResultType = String(
          resultType ?? ""
        )
          .trim()
          .toLowerCase();

        let expectedAverage = 0;

        if (normalizedResultType === "test") {
          expectedAverage = testAverage;
        } else if (normalizedResultType === "exam") {
          expectedAverage = examAverage;
        } else if (
          Math.abs(metaAverage - testAverage) <= 0.1
        ) {
          expectedAverage = testAverage;
        } else if (
          Math.abs(metaAverage - examAverage) <= 0.1
        ) {
          expectedAverage = examAverage;
        }

        const hasValidData =
          Number.isFinite(metaAverage) &&
          Number.isFinite(expectedAverage) &&
          metaAverage > 0 &&
          expectedAverage > 0;

        const isCloseEnough =
          Math.abs(metaAverage - expectedAverage) <= 1;

        const isValid =
          hasValidData && isCloseEnough;

        return isValid ? (
          <>
            <button
              type="button"
              onClick={handlePrint}
              className="btn btn-lg btn-dark rounded-pill me-2"
            >
              Print Result
            </button>

            <button
              type="button"
              onClick={handleExportReportWord}
              className="btn btn-lg btn-purple4 text-white rounded-pill"
            >
              Export Word
            </button>
          </>
        ) : (
          <div className="text-danger fw-bold fs-5 py-2">
            {avg?.message ||
              `Result is invalid (${metaAverage} ≠ ${expectedAverage})`}
          </div>
        );
      })()}
    </div>
  </div>
</>
              ) : (
                <div className="fs-3 text-center text-dark py-5">
                  No result data available to display.
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

        <div
        className="offcanvas offcanvas-bottom bg-dark text-white"
        data-bs-scroll="true"
        data-bs-backdrop="false"
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasBottomLabel"
        style={
          isMobile
            ? { height: "100%" }
            : {
                height: toggle ? "500px" : "70px",
                width: "600px",
                marginLeft: "30%",
                borderTopLeftRadius: "30px",
                borderTopRightRadius: "30px",
              }
        }
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <div
            className="offcanvas-title fs-t fw-medium text-gray-400"
            id="offcanvasBottomLabel"
          >
            Result Send Console
          </div>

          <button
            className="btn btn-white btn-icon rounded-br-lg2 rounded-bl-sm2 rounded-t-lg2"
            onClick={() => setToggle(!toggle)}
          >
            {toggle ? (
              <i className="bi bi-fullscreen-exit fs-3 text-dark"></i>
            ) : (
              <i className="bi bi-fullscreen fs-3 text-dark"></i>
            )}
          </button>
        </div>

        <div className="offcanvas-body small">
          
          <div
            className="bg-black text-success p-2 rounded"
            style={{ height: "380px", overflowY: "auto", fontFamily: "monospace" }}
          >
            {logs.map((log, i) => (
              <div key={i} className="border-bottom border-secondary py-1">
                {log}
              </div>
            ))}
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default Result;
